import React, {useEffect, useState} from "react"
import { useLocation, useNavigate } from "react-router-dom";
import {viewPoolData} from "../userpool";
import {BETA_VIEW_LINK_URL, BETA_VIEW_STATUS_URL, VIEW_LINK_SESSION_CHECK_DELAY} from "../common/constants";
import {isSessionValid} from "../services/authenticate";

const INSIGHTS_ARE_NOT_READY = "עדיין אין תובנות להציג";
const CONSENT_MISSING = "אין הסכמות בתוקף";
const ADD_NEW_CONSENT = "יצירת הסכמה חדשה";


const ViewLink = () => {
  const [aisLink, setAisLink] = useState("#");
  const [viewLink, setViewLink] = useState("#");
  const [consentButtonStyle, setConsentButtonStyle] = useState("button isDisabled");
  const [viewButtonStyle, setViewButtonStyle] = useState("button isDisabled");
  const navigate = useNavigate();
  const location = useLocation();
  const [userConsents, setUserConsents] = useState([]);
  const [userInsights, setUserInsights] = useState([]);
  const consentData = {srv: "view_ais/user"}
  const viewData = {srv: "view/user"}
  const consentStatus = {action: "status"}
  let insightsInterval;

  useEffect(() => {
    if (!isSessionValid(viewPoolData)) navigate("/login", {state: {from: "view"}})
    setInterval(() => {
      if (!isSessionValid(viewPoolData)) {
        localStorage.removeItem("statusToken");
        navigate("/login", {state: {from: "view"}});
      } else {
        console.log("Session is active")
      }
    },VIEW_LINK_SESSION_CHECK_DELAY)
  }, []);

  const getInsights = () => {
    postData(BETA_VIEW_STATUS_URL, {type: "insight", statusToken: localStorage.getItem("statusToken"), ...consentData, ...consentStatus}).then((insightsData) => {
      if (insightsData.length) {
        postData(BETA_VIEW_LINK_URL, viewData).then((data) => {
            setViewLink(data.link);
            setViewButtonStyle("button isEnabled")
          })
            setUserInsights(insightsData)
          }
      })
  }

  useEffect(()=>{
    let data;
    let buttonStyleSetter;
    // define proper payload for consent creation or for view page
    if (location.search && location.search.includes("userId")) {
      data = viewData;
      buttonStyleSetter = setViewButtonStyle;
    }
    else {
      data = consentData;
      buttonStyleSetter = setConsentButtonStyle;
    }
    const asyncFn = async() => postData(BETA_VIEW_LINK_URL, data)
      .then((data) => {
        setAisLink(data.link);
        const token = (new URLSearchParams(data.link.split("?")[1])).get("token");
        localStorage.setItem("statusToken", token)
        // set proper button style (Consent or View)
        buttonStyleSetter("button isEnabled")
        getUrls()
    })
    .catch((e) => {
      if (e) {
        console.log(e);
      }
    });
    asyncFn();
    const getUrls = () => {
      postData(BETA_VIEW_STATUS_URL, {
        type: "consent",
        statusToken: localStorage.getItem("statusToken"), ...consentData, ...consentStatus
      })
        .then((consentsData) => {
          if (consentsData.length) {
            setUserConsents(consentsData)
            getInsights()
            if (!userInsights.length) {
              console.log("Getting insights")
              insightsInterval = setInterval(() => {
                getInsights()
              }, 5_000)
            } else {
              console.log("Insights are available")
              clearInterval(insightsInterval)
            }
          }
        })
    }
  },[navigate]);

  async function postData(url = "", data = {}) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Authorization": sessionStorage.getItem("token"),
      },
      redirect: "follow",
      body: JSON.stringify(data),
    });
    return response.json();
  }

  return (
    <div className="container">
      <img className="logo" src="logo.png" alt="Logo" width="200" height="100" style={{margin: "auto"}}/>
      <h1 className="header">Feezback View-ברוכים הבאים ל</h1>
      <p dir="rtl" className="text">
        <span style={{fontWeight: "bold"}}>חיבור חשבונות בנק וצפייה בדו״ח תובנות באמצעות בנקאות פתוחה</span>
        <br/><br/>
        1.&nbsp;התחילו ביצירת הסכמה חדשה
        <br/>
        2.&nbsp;לאחר מתן ההסכמה תוכלו לצפות בדו״ח התובנות
        <br/><br/>
        *ההסכמה היא חד פעמית - הפרטים נמחקים בתוך 7 ימים.
        <br/>
        *לאחר יצירת ההסכמה, יש להמתין מספר דקות עד לזמינות התובנות.
      </p>
      <a href={aisLink} className={consentButtonStyle} id="consent-link-href" target="_self">
        { aisLink === "#" ? "...אנא  המתן לטעינת האפליקציה של פיזבק" : userConsents.length ? ADD_NEW_CONSENT : "בואו נתחיל"}
      </a>
      <a href={viewLink} className={viewButtonStyle} id="view-link-href" target="_blank">
        {userInsights.length ? "לצפייה בתובנות שלך" : userConsents.length ? INSIGHTS_ARE_NOT_READY : CONSENT_MISSING}
      </a>
    </div>
  )
}

export default ViewLink;
